export default __webpack_public_path__ + "static/media/jonah_kagen.d9a78452.jpeg";